import React from 'react';

export const SalesOnBoarding = React.createContext();
